import { createRef, RefObject, useEffect } from 'react';
import { useTranslation } from 'next-i18next';
import { IPointOfPresenceWithDetails } from '@features/checkout/typescript';
import ShowroomCard from '@features/showrooms/sections/ShowroomSection/Components/ShowroomCard/ShowroomCard';
import ShowroomOffer from '@features/showrooms/sections/ShowroomSection/Components/ShowroomOffer/ShowroomOffer';
import LogoBar from '@features/showrooms/sections/ShowroomSection/Components/LogoBar/LogoBar';
import ServiceInfo from '@features/showrooms/sections/ShowroomSection/Components/ServiceInfo/ServiceInfo';
import FullImageWithHeading from '@features/cms/components/pages/FullImageWithHeading/FullImageWithHeading';
import getFullImageWithHeadingData from '@features/showrooms/sections/ShowroomSection/ShowroomSectionBase';
import getFullImageWithHeadingDataDIP from '@features/showrooms/sections/ShowroomSection/ShowroomSectionBaseDIP';
import FourProjects from '@features/showrooms/sections/ShowroomSection/Components/FourProjects/FourProjects';
import { handleEmptyGallery } from '@utils/showroom';
type PropsType = {
  showroom: IPointOfPresenceWithDetails;
  showPartnersLogos: boolean;
};
const ShowroomSection = ({
  showroom,
  showPartnersLogos
}: PropsType) => {
  const {
    t
  } = useTranslation('common');
  const offerSection: RefObject<HTMLInputElement | null> = createRef();
  const hasOfferDescription = (): boolean => showroom?.description?.offer && showroom.description.offer.length > 0 || false;
  const getOfferDescription = (): string | null => showroom?.description?.offer ? showroom?.description?.offer : null;
  const scrollToOffer = () => offerSection?.current && offerSection.current.scrollIntoView({
    behavior: 'smooth'
  });
  useEffect(() => {
    if (showroom?.gallery) showroom.gallery = handleEmptyGallery(showroom.gallery);
  }, [showroom]);
  const groupCode = showroom?.group?.code;
  const useDipFullImage = groupCode === 'VOX_DIP' || groupCode === 'VOX_INTERIORS';
  return <>
      <ShowroomCard showroom={showroom} offerButton={hasOfferDescription()} scrollToOffer={scrollToOffer} />
      <div ref={offerSection}>{hasOfferDescription() && <ShowroomOffer description={getOfferDescription()} />}</div>
      {showPartnersLogos && useDipFullImage && <LogoBar />}
      {showroom?.services?.length ? <ServiceInfo services={showroom?.services} /> : null}
      {useDipFullImage}
      {useDipFullImage ? <FullImageWithHeading data={getFullImageWithHeadingDataDIP(t)} /> : <FullImageWithHeading data={getFullImageWithHeadingData(t)} />}
      <FourProjects />
    </>;
};
export default ShowroomSection;